<div class="unauthorized-container">
  <div class="unauthorized-card">
    <div class="card-header">
      <h1>Access Denied</h1>
    </div>

    <div class="card-content">
      <div class="error-icon">⛔</div>
      <h2>403 - Forbidden</h2>
      <p>You don't have permission to access this page.</p>
      <p>Please contact your administrator if you believe this is an error.</p>
    </div>

    <div class="card-actions">
      <button *ngIf="!authService.isAuthenticated()" class="btn btn-primary" (click)="navigateToLogin()">
        Back to Login
      </button>
      <button *ngIf="authService.isAuthenticated()" class="btn btn-secondary" (click)="navigateToHome()">
        Back to Home
      </button>
    </div>
  </div>
</div>
